import { useUserBonusClaimCheckpoint } from '@/api/user-bonus';
import { useAnimateOnStatusChange } from '../useAnimateOnStatusChange';
import { UserBonusCheckpoints } from '@/models/userBonus/checkpoint';
import { UserBonus } from '@/models/userBonus';
import { useLottiePlayer } from '@starsoft/common/hooks';
import { UserBonusCheckpointStatus } from '@/enums/userBonusCheckpointStatus';

export function useUserBonusCheckpoint(
  checkpoint?: UserBonusCheckpoints,
  userBonus?: UserBonus,
) {
  const { claimBonus, loadingClaimBonus } = useUserBonusClaimCheckpoint();
  const { animate } = useAnimateOnStatusChange(checkpoint?.status);
  const { lottieAnimationRef } = useLottiePlayer({
    path: '/confetti.json',
    loop: false,
    dependecyArray: [animate],
  });

  function handleClaimBonus() {
    if (checkpoint?.status != UserBonusCheckpointStatus.Fulfilled) {
      return;
    }

    claimBonus({
      fraction: checkpoint?.fraction,
      userBonusId: userBonus?.id,
    });
  }

  return {
    loadingClaimBonus,
    lottieAnimationRef,
    animate,
    handleClaimBonus,
  };
}
